import { useNavigate } from 'react-router-dom';

import {
  cajaPrimariaFormSchema,
  gridSizeMdLg12,
  gridSizeMdLg4,
  // EstadoOLTOptions,
  gridSizeMdLg6,
  gridSizeMdLg8,
  ROUTER_PATHS,
  useCheckPermissionsArray,
  useLoaders,
  useMapComponent,
} from '@/shared';
import {
  CreateCajaPrimariaParams,
  getFlotaAll,
  // CreateOLTParams,
  useCreateCajaPrimaria,
  useFetchAreas,
  // useCreateOLT,
  useFetchOLTs,
  useUpdateCajaPrimaria,
  // useUpdateOLT,
} from '@/shared/actions/erp';
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  // CustomAutocompleteArrString,
  // CustomNumberTextField,
  // CustomNumberTextField,
  // CustomPasswordTextField,
  // CustomTextArea,
  CustomTextField,
  SampleDatePicker,
  SingleFormBoxScene,
  SwitchComponenteForm,
} from '@/shared/components/ui';
import {
  AlertSeverityEnum,
  Area,
  CajaPrimaria,
  CajaPrimariaEstadoFisicoEnum,
  Flota,
  OLT,
  OptionsCajaPrimariaEstadoFisico,
  // Pais,
  // Province,
  // Zone,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { SAVE_CAJA_PRIMARIA_PERMISSIONS } from '../../constants';
import CustomCoordendasForm from '@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm';
import dayjs from 'dayjs';
import CustomAutocompleteFetchForm from '@/shared/components/ui/CustomAutocompleteFetchForm';
import useAutocompleteFetch from '@/shared/hooks/useAutocompleteFetch';

export interface SaveCajaPrimariaComponentProps {
  title: string;
  cajaPrimaria?: CajaPrimaria;
}

type SaveFormData = CreateCajaPrimariaParams & {
};

const SaveCajaPrimariaComponent: React.FC<SaveCajaPrimariaComponentProps> = ({ title, cajaPrimaria }) => {
  useCheckPermissionsArray(SAVE_CAJA_PRIMARIA_PERMISSIONS);

  const returnUrlCajasPrimariasPage = ROUTER_PATHS.configuracionRED.cajaPrimariaNav;
  const navigate = useNavigate();

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(cajaPrimariaFormSchema as any),
    defaultValues: {
      estado_caja_primaria:CajaPrimariaEstadoFisicoEnum.PENDIENTE,
      coordenadas: cajaPrimaria?.coordenadas ?? '0,0',
      fecha_instalacion: cajaPrimaria?.fecha_instalacion ?? dayjs().format('YYYY-MM-DD'),
    }
  });

  const {
    // control,
    handleSubmit,
    formState: { errors },
    reset,
  } = form;


  ///* store
  const setAlert = useUiStore(s => s.setAlert);

  const {
    fetchAutocompleteFlota
  } = useAutocompleteFetch();



  // mapa con naps 
  const {
    Map: MapaComponente,
    latLng,
    setLatLng,
    napsByCity,
    setCurrentCoordenadas,
    // isLoadingNapsByCity,
    currentCoordenadas,
  } = useMapComponent({
    form,
    currentCity: "",
    coordenadasCliente: cajaPrimaria?.coordenadas ?? '',
  });


  const {
    data: allOlts,
    isLoading: isLoadingolts,
    isRefetching: isRefetchingolts,
  } = useFetchOLTs({
    enabled: true, ///* zona
    params: {
      page_size: 1000,
    },
  });

  

  ///* mutations
  const createCajaPrimaria = useCreateCajaPrimaria({
    navigate,
    returnUrl: returnUrlCajasPrimariasPage,
  });
  const updateCajaPrimaria = useUpdateCajaPrimaria({
    navigate,
    returnUrl: returnUrlCajasPrimariasPage,
  });
  const {
    data: areaPagingRes,
    isLoading: isLoadingAreas,
  } = useFetchAreas(
    {
      page_size: 1000,
    },
    true
  );


  useEffect(() => {

    if (!cajaPrimaria) return;

    reset(cajaPrimaria)

    const coordenada = cajaPrimaria.coordenadas;

    if (!coordenada) return;


    return () => {

    }
  }, [cajaPrimaria])


  ///* handlers
  const onSave = async (data: SaveFormData) => {
    data.latitud = data.coordenadas.split(",")[0]
    data.longitud = data.coordenadas.split(",")[1]
    // data.potencia_maxima = data.potencia_maxima?.toString()
    // data.potencia_minima = data.potencia_minima?.toString()
    ///* update
    if (cajaPrimaria) {
      await updateCajaPrimaria.mutateAsync({
        id: cajaPrimaria.id_caja_primaria!,
        data: {
          ...data,
        },
      });
      return;
    }

    ///* create
    await createCajaPrimaria.mutateAsync(data);
  };


  useLoaders(
    isLoadingolts
  )

  return (
    <SingleFormBoxScene
      titlePage={title}
      onCancel={() => navigate(returnUrlCajasPrimariasPage)}
      onSave={handleSubmit(onSave, (errors) => {
        setAlert(true, 'Existen problemas con los datos ingresados', AlertSeverityEnum.error)
        console.log('errors', errors);
      })}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={form.control}
        defaultValue={form.getValues().nombre}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        size={gridSizeMdLg12}
      />
      <CustomTextField
        label="Puerto PON"
        name="tarjeta"
        defaultValue={form.getValues().tarjeta}
        control={form.control}
        error={errors.tarjeta}
        helperText={errors.tarjeta?.message || "Estructura de tipo: 0/1/15"}
        size={gridSizeMdLg6}
      />
      


      <CustomAutocomplete<OLT>
        label="OLT"
        name="olt"
        //// options
        options={allOlts?.data?.data || []}
        // label & id as fk
        valueKey="nombre"
        actualValueKey="codigo"
        defaultValue={form.getValues().olt || ''}
        isLoadingData={isLoadingolts || isRefetchingolts}
        //// validation
        control={form.control}
        error={errors.olt}
        helperText={errors.olt?.message}
        size={gridSizeMdLg6}
      />
      {/* <CustomNumberTextField
        label="Potencia máxima (dbm)"
        name="potencia_maxima"
        defaultValue={form.getValues().potencia_maxima}
        control={form.control}
        error={errors.potencia_maxima}
        helperText={errors.potencia_maxima?.message}
        size={gridSizeMdLg6}
        required={false}
      />

      <CustomNumberTextField
        label="Potencia mínima (dbm)"
        name="potencia_minima"
        defaultValue={form.getValues().potencia_minima}
        control={form.control}
        error={errors.potencia_minima}
        helperText={errors.potencia_minima?.message}
        size={gridSizeMdLg6}
        required={false}
      /> */}


      <CustomAutocompleteArrString
        label="Splitter"
        name="splitter"
        isLoadingData={false}
        options={["1*8"]}
        defaultValue={"1*8"}
        control={form.control}
        error={errors.splitter}
        helperText={errors.splitter?.message}
        size={gridSizeMdLg6}
      />
      <CustomAutocomplete<Area>
        label="Área Responsable"
        name="area_responsable"
        options={areaPagingRes?.data?.data?.filter((area: Area) => ["NOC", "PROYECTOS"].includes(area.nombre)) || []}
        valueKey="nombre"
        actualValueKey="codigo"
        defaultValue={form.getValues().area_responsable}
        optionLabelForEdit={form.getValues().area_responsable}
        isLoadingData={isLoadingAreas}
        control={form.control}
        error={form.formState.errors.area_responsable}
        helperText={
          form.formState.errors.area_responsable?.message
        }
        size={gridSizeMdLg6}
        required={false}
      />

      <CustomAutocompleteArrString
        label="Estado Físico de Manga"
        name="estado_caja_primaria"
        control={form.control}
        defaultValue={CajaPrimariaEstadoFisicoEnum.PENDIENTE}
        options={OptionsCajaPrimariaEstadoFisico}
        isLoadingData={false}
        error={errors.estado_caja_primaria}
        helperText={errors.estado_caja_primaria?.message}
        size={gridSizeMdLg8}
        disableClearable
      />
      <SwitchComponenteForm
        label={form.watch()?.estado ? 'Activo' : 'Inactivo'}
        size={gridSizeMdLg4}
        control={form.control}
        defaultValue={!!form.getValues()?.estado}
        name="estado"
      />
      <SampleDatePicker
        name="fecha_instalacion"
        label="Fecha de Instalación"
        control={form.control}
        defaultValue={form.getValues().fecha_instalacion || ""}
        error={errors.fecha_instalacion}
        helperText={errors.fecha_instalacion?.message}
        // shrink={shrink}
        size={gridSizeMdLg12}
        required={false}
      />
      {/* <CustomTextField
        label="Nombre Técnico Instalación"
        name="nombre_tecnico_instalacion"
        control={form.control}
        defaultValue={form.getValues().nombre_tecnico_instalacion || "N/D"}
        error={errors.nombre_tecnico_instalacion}
        helperText={errors.nombre_tecnico_instalacion?.message}
        size={gridSizeMdLg12}
        shrink={true}
      /> */}

      <CustomAutocompleteFetchForm<Flota>
        control={form.control}
        required={false}
        size={gridSizeMdLg12}
        name="nombre_tecnico_instalacion"
        label="Nombre Técnico Instalación"
        fetchData={fetchAutocompleteFlota} ///* TODO: Pendiente revisar
        getOptionLabel={(opt) => `${opt.nombre}` || ''}
        initialInputValue={form.getValues()?.nombre_tecnico_instalacion ?? ''}
        fetchParams={{
          disable_all_option: true
        }}
        key={'autocomplete-nombre_tecnico_instalacion'}
        getOptionKey={(opt) => opt.nombre}
        isAll={false}
        loadOptionByValue={async (nombre) => {
          console.log('nombre', nombre);
          const res = await getFlotaAll({
            nombre: nombre as string
          });
          return res.data.data[0] ?? null

        }}
        //getValue={(opt) => opt.codigo}
        //valueKey="codigo"
        onChangeValue={(e) => {
          form.setValue('nombre_tecnico_instalacion', e as string)

        }}
      />


      {/* ========= Detalles Instalacion ========= */}
      {/* ========== nap ========== */}
      <CustomCoordendasForm
        form={form}
        required={false}
        label="Coordendas"
        name="coordenadas"
        defaultValue={form.watch().coordenadas}
        key={'key_bras_coordenadas'}
        size={gridSizeMdLg12}
        onlyValueLocation={true}
        enableLocationOnChange={false}
        handleDataUbicacion={(watchedCoordenadas) => {

          if (!watchedCoordenadas) return;

          setLatLng({
            lat: +watchedCoordenadas.split(',')[0],
            lng: +watchedCoordenadas.split(',')[1],
          })

          setCurrentCoordenadas(watchedCoordenadas);

        }}
      />
      {currentCoordenadas && (
        <MapaComponente
          canDragMarker={false}
          coordenadas={latLng}
          napsByCity={napsByCity || []}
          setLatLng={setLatLng}
        />
      )}


      


    </SingleFormBoxScene>
  );
};

export default SaveCajaPrimariaComponent;
